module.exports = __webpack_public_path__ + "static/img/Edrick-Lee.eedf5e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Edrick-Lee.jpg
// module id = YHn/
// module chunks = 0